(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8875],{

/***/ 72017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/marketing/grailed-seller-guide/index.tsx







function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2022-02-22",
      tag: "Grailed",
      title: "Grailed Seller Guide: Everything You Need to Know",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["There are many reasons why you might want to sell your items on Grailed. It can be an easy way to make extra cash, a hobby, or just a passion. Grailed is a popular online menswear resale marketplace that allows users to buy and sell men's fashion, accessories, shoes, and designer items.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["If you are thinking about becoming a Grailed seller, this blog will discuss everything you need to know. It includes how to list an item, seller fees, and processes. So if you're looking for the best way to sell your designer sneakers or limited edition clothes online, keep on reading!", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "What is Grailed "
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Grailed is a luxury fashion marketplace for men specializing in streetwear, designer items, and high-end sneakers. Founded in 2013 by Arun Gupta and Alex Brown, the website has over 5 million members who buy and sell clothes. As of 2021, Grailed lists about three million clothing items from around 7 million users on its platform."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["This is a reseller's haven for limited-edition sneakers and collabs. Sellers can list an item for sale or start bidding on the designer or rare items. Buying in Grailed is free, but selling on this platform comes with fees.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Grailed Selling Fees "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Grailed charges a 9% commission fee for each transaction. The seller also needs to pay a PayPal Fee (both for domestic and international transactions). The PayPal fee percentage depends on where the buyer's billing address is.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Domestic PayPal Fee - 2.9%+ 30 cents "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "International PayPal Fee - 4.4% + 30 cents "
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Grailed commission fees are charged to keep the app from running smoothly. At the same time, the PayPal fees are paid for the payment processing and protect its users against scams or fraudulent activities. Compared with other marketplaces such as eBay (10%), Grailed's commission fee is relatively lower.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Binding Offers"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Offers made in Grailed are binding. Meaning agreements are made first between the buyer and the seller. This allows serious and well-balanced negotiations. When a buyer sends a binding offer, and the seller accepts it, the sale is confirmed, and the payment is completed."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["If the seller declines the offer, Grailed will charge no fee to the buyer's account. However, PayPal will only release the fund after the shipment has been confirmed.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "How Sellers are Paid"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Grailed sellers are paid directly on their PayPal account after the buyer receives the item(s). Make sure to have a copy of the shipping label for any issues that may arise.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["As long as the seller provides a valid tracking number, Grailed will release the funds on their PayPal account. However, please be reminded that some sellers may experience delays in fund releasing.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["PayPal will hold your funds if the item is not yet shipped or you do not provide valid tracking. The fund will be released after the buyer confirms the shipment or three days after delivery. Whether sending domestic or international, remember to always add the tracking.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "To do this, follow the steps below: "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Take a photo of the shipping label "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Go to Messages and click the buyer"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Select \"Add Tracking\""
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Some new sellers may experience delay up to 28 days. PayPal may ask for more details or verification. For new sellers, it is essential to enter all relevant information to avoid further delays.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "How to Sell on Grailed "
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "The internet has changed the way we buy and sell products. One of the most popular websites for buying and selling sneakers is Grailed. There are many ways to market on Grailed, and we will go over some essential tips that will make your listings more successful."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Create An Account and Make a Listing "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["You must set up an account first before you can buy and sell on Grailed. Make sure to enter all relevant information on your account. Sellers with a profile picture, complete details, and optimized profiles are more trustworthy.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Signing up can only take a few minutes. Simply go to Grailed.com, click the \"sign-up\" button, enter your details, and you're done. People who do not have an account can search on the site but cannot access Grailed features and tools. To start selling, you must first make a listing. Go to your Home dashboard and click the \"sell\" button to create your first listing.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Listing Title and Description"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["The listing title and product description play a vital role in getting your listing found by more potential buyers. Make sure to fill in relevant information about the item you are selling. Your listing title should contain essential things such as brand name, size, color, and condition.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Since the listing title has character limits, make sure to use the product description to add more details. You can make a checklist to ensure your buyers get all the relevant information about your item. Make sure to include the following:", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Add the designer name "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Add color"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Add actual size (Size shown on the label)"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Add exact measurement (e.g., width, length, height, etc.)"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Item's condition (e.g.8/10, with a small hole, etc.)"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Retail Price (Insert the original price of the item)"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Shipping (e.g., Ships within 1-2 days) "
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Be as descriptive as possible. This will lessen potential questions for your buyers and speed up their buying decision. For high-end items, make sure to add authenticity tags and have them digitally authenticated. The authentication process can take up to 48 hours.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Listing Tags "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Listing tags help your listing be seen by more potential buyers and connect you to the right buyers. You can add up to 10 tags per listing with 32 characters. Make sure to choose relevant listing tags for optimal results.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Listing tags are similar to hashtags. These are clickable and are shown on your listing page and search results. Choose the best tags that described your item, such as eras, styles, genres, seasons, features, etc. (i.e., #sneakerhead, #punk #customized #NBA #SupremeCollab)", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Taking Quality Photos "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Photos are the heartbeat of your listing. Upload at least three photos in your listing, and make sure your item is evident in the first photo. A blurry, messy, or unorganized background can lose a potential buyer's interest. Here are a few tips for taking quality shots of your product.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Use Natural Light"
          }), " - Take photos of your items in a well-lighted area. You can take pictures of your items next to or near a window during daylight. Take pictures of the items at different angles and avoid taking pictures in direct sunlight or a dark room. This can cast shadows and yellow tints in your item.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Neat Background"
          }), " - Make sure to find a simple and clean background for your items. Avoid printed, dark colors or messy backgrounds. Many photo editing apps allow you to edit or remove backgrounds and unwanted elements in your photos.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Upload 3 or more photos"
          }), " - Grailed allows sellers to upload up to 12 pictures in a listing. Make sure to add the front, sides, top, and bottom images. Also, add relevant details such as measurement, label, materials used, and item's condition (signs of wear, stains, etc.)", ' ']
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Add Tagged Photo "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Adding a tagged photo provides extra confidence for your buyers. This way, buyers can ensure that the item you are selling is yours.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "How to Tag a Photo:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Get a sheet of paper "
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["On that paper, write your Grailed username and today's date *Make sure the word \"Grailed\" is seen and easily read.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Take a photo of the paper alongside your listed item. "
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Adding a tagged photo in your listed items proves ownership. The tagged photos also served as your trademark against photo grabbers.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Select Your Market "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["To help the users easily find what they are looking for and connect them with the right seller, Grailed categories are divided by Market. These markets are Grails, Hype, Sartorial, and Core.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Grails"
          }), " - These are categories for the designer and high-valued items. (i.e,., Balmain, Gucci, Rick Owens, Saint Laurent, etc.)", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Hype"
          }), " - These are categories for in-demand and highly anticipated releases and collabs (i.e., Yeezy, Jordan, Supreme, BBC, New Drops, etc.)", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Sartorial"
          }), " - These are categories for high-end classic menswear and fashion (i.e., Tom Ford, Kiton, Alden, Drakes, etc.)", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Core"
          }), " - These are mainstream brands (i.e., Levi's, Polo, H&M, Zara, Gap, Ralph Lauren, etc.)", ' ']
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Pricing "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Even in the resale community, everyone wants a fair price. If you are unsure of the market price, try to do a little research first. Look for the similar item listed on Grailed and other resale platforms.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["If you want to sell your item faster, price your item lower than your competitors. For limited-edition items, you can have it bid to get the best price. Remember that we want to get the best value for our items.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Do not base your pricing on retail, especially for highly anticipated new drops and releases. Check the market demand or browse through sold listings feed. Make sure to find your product's worth and how much the buyers are willing to spend on it.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Shipping"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["You just made your first sale. Congrats! What do you do next? These are probably the questions you have after confirming your sale on Grailed. There are two ways to ship on Grailed. The Grailed labels and \"My Own Shipping Label.\"", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Grailed Labels "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Grailed has its own shipping label called Grailed label. This promises an easy and cost-effective method for shipping your sold items within the U.S. For international shipments, you can set the shipping by toggling the region under \"International Shipping.\"", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "My Own Shipping"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["You have the option to choose which courier works for you best. Sellers usually choose \"My Own Shipping\" for international shipments. You can also use this if you prefer to find lower shipping costs or your items weigh more than 9kgs. Keep in mind that you still need to have accurate tracking and proof of shipment.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Shipping via Grailed Label "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Shipping using a Grailed label is easy and pretty straightforward. You just have to input your return shipping address in your address book. You can also add your return shipping address when creating a listing.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Keep in mind to get the exact weight and dimension of the item you are selling. This way, you can set the shipping costs precisely and avoid paying for any excess.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["After confirming a sale, You can print the Grailed label from your listing or via the messages with your buyer. Simply print and pack the item. You can request the parcel be picked up at your address or have it dropped off at the nearest post office.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Pro-tip"
        }), " - Grailed labels are insured up to $50 if USPS loses the parcel while in transit. If you need additional assurance for high-valued items, we suggest arranging your shipment via \"My Own Shipping.\"", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "How to Sell Sneakers Effectively "
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Sneakers are some of the most popular items on Grailed. You can sell sneakers that retail for over $200, as well as more niche and designer kicks. If you're looking to make a few bucks from your closet, or if you're an aspiring sneakerhead with too many pairs and not enough space in your apartment, here's how to sell your sneakers effectively on Grailed."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Digital Authentication"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["If you are planning to sell your limited edition kick or high-valued collab apparel. It needs to get digitally authenticated first. Having your items digitally certified by Grailed in-house moderators build trust and assurance to your buyers. Grailed may ask for more information and authenticity indicators for susceptible brands and styles.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Add Tagged Photo "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Adding tagged photos to your items also builds trust and legitimacy. It serves as proof of ownership and is known to help sell an item much faster. Tagged photo works best on high-risk, highly anticipated, and high-value items.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Re-list and Cross-list "
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "To sell more products, your listings must be seen by more customers. If you want to sell your sneakers fast enough, you should re-list and cross-list to get more views. With a lot of competition around the market, it is essential to take your reselling game to the next level."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Re-listing and cross-listing can take a few minutes or even hours for closets with hundreds of items. That is why automation and cross-listing tools can come in handy to expose your listings on multiple platforms.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "This is where OneShop comes in handy. Our intelligent system does all the tedious work with reselling on multiple marketplaces. OneShop can automate listing tasks such as sharing, following, liking, re-listing, and cross-listing to Mercari and other platforms (soon!) like Grailed."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["If you're also selling on Poshmark, Mercari, and Depop, OneShop offers a 7-day free trial for marketplace sellers with no credit card information and commitment required! Sign up", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://tools.oneshop.com/signup",
          children: "here"
        }), " or visit", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://tools.oneshop.com/",
          children: "https://tools.oneshop.com/"
        }), " to know more.", ' ']
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/grailed-seller-guide.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Grailed Seller Guide: Everything You Need to Know"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Read on the must-knows for those looking to sell on Grailed. "
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/grailed-seller-guide"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/grailed-seller-guide"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "Grailed Seller Guide: Everything You Need to Know"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "Read on the must-knows for those looking to sell on Grailed. "
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=4"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "February 22nd, 2022"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "February 22nd, 2022"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "Grailed"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 70381:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/grailed-seller-guide",
      function () {
        return __webpack_require__(72017);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(70381); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);